<!-- eslint-disable rulesdir/no-retired-components -->
<template>
  <div class="input-title">
    <span v-if="title">
      {{ title }}
    </span>

    <slot v-else />

    <komodo-help-text
      v-if="help"
      :text="help"
    />

    <komodo-tooltip
      v-if="infoTooltipText"
      :max-width="300"
    >
      <template #hoverSlot>
        <komodo-icon
          icon="info"
          class="info-icon"
          :size="KomodoIconSize.Small"
        />
      </template>
      <template #textSlot>
        {{ infoTooltipText }}
      </template>
    </komodo-tooltip>

    <div
      v-if="rightAside()"
      class="right-aside"
    >
      <slot name="right-aside" />
    </div>
  </div>
</template>

<script lang="ts">
/* eslint-disable rulesdir/no-retired-components */
import { getCurrentInstance } from 'vue'

import KomodoTooltip from 'komodo2/components/KomodoTooltip.vue'
import KomodoIcon, { Size as KomodoIconSize } from 'shared/components/KomodoIcon.vue'
import KomodoHelpText from 'shared/components/KomodoHelpText.vue'

export default {
  name: 'KomodoInputTitle'
}
</script>

<script setup lang="ts">
interface Props {
  title?: string
  help?: string
  infoTooltipText?: string
}

withDefaults(defineProps<Props>(), {
  title: '',
  help: '',
  infoTooltipText: ''
})

const root = getCurrentInstance()

const rightAside = () => {
  return root?.proxy.$slots['right-aside'] !== undefined
}
</script>

<style lang="scss" scoped>
.input-title {
  @include font-label-l2-label-inline;

  margin-bottom: 4px;
  display: flex;
  color: $gray-2-87;

  .help-text {
    margin-left: 8px;
  }

  .right-aside {
    margin-left: auto;
  }

  .info-icon {
    @include color-gray-4-24;

    line-height: 20px;
    margin-left: 4px;
  }
}
</style>
